const CONFIGURED_ATTACHMENT_ORIGIN_KEYS = [
  'hostURL',
  'apiHost',
  'storageURL',
  'storageUrl',
  'storageHost',
  'assetURL',
  'assetUrl',
  'assetHost',
];

const browserOrigin = () =>
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : '';

const configuredOrigins = ({ baseOrigin, config }) => {
  const origins = new Set();
  if (baseOrigin) origins.add(baseOrigin);

  CONFIGURED_ATTACHMENT_ORIGIN_KEYS.forEach(key => {
    const configuredUrl = config?.[key];
    if (typeof configuredUrl !== 'string' || !configuredUrl.trim()) return;

    try {
      const parsedUrl = new URL(configuredUrl.trim(), baseOrigin);
      if (
        ['http:', 'https:'].includes(parsedUrl.protocol) &&
        !parsedUrl.username &&
        !parsedUrl.password
      ) {
        origins.add(parsedUrl.origin);
      }
    } catch {
      // Invalid deployment configuration must never broaden the allow-list.
    }
  });

  return origins;
};

export const resolveTrustedAttachmentUrl = (
  rawUrl,
  {
    baseOrigin = browserOrigin(),
    config = typeof window !== 'undefined' ? window.chatwootConfig || {} : {},
  } = {}
) => {
  if (typeof rawUrl !== 'string' || !rawUrl.trim() || !baseOrigin) return '';

  try {
    const parsedUrl = new URL(rawUrl.trim(), baseOrigin);
    if (
      !['http:', 'https:'].includes(parsedUrl.protocol) ||
      parsedUrl.username ||
      parsedUrl.password ||
      !configuredOrigins({ baseOrigin, config }).has(parsedUrl.origin)
    ) {
      return '';
    }

    return parsedUrl.href;
  } catch {
    return '';
  }
};

export const trustedAttachmentUrl = (attachment, options) =>
  resolveTrustedAttachmentUrl(
    attachment?.url || attachment?.attachment_url || attachment?.file_url,
    options
  );
